const routes = [
// 外部账号限制访问的路由只能是 /external 开头的
{
  path: "/external/login",
  name: "externalLogin",
  component: () => import("@/modules/external/pages/login/index.vue"),
  meta: {
    title: "登录",
    hidden: false,
    icon: "tree",
    isNew: true,
    needLogin: false
  }
}, {
  path: "/external/communityList",
  name: "externalCommunityList",
  component: () => import("@/modules/external/pages/community/communityList.vue"),
  meta: {
    title: "社区列表",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/activityList",
  name: "externalActivityList",
  component: () => import("@/modules/external/pages/community/activityList.vue"),
  meta: {
    title: "活动列表",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/dataOverview",
  name: "externalDataOverview",
  component: () => import("@/modules/external/pages/community/dataOverview.vue"),
  meta: {
    title: "数据概览",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/liveStreamFollowerManagement",
  name: "liveStreamFollowerManagement",
  component: () => import("@/modules/external/pages/community/liveStreamFollowerManagement.vue"),
  meta: {
    title: "讲堂跟播管理",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/articleEdit",
  name: "externalarticleEdit",
  component: () => import("@/modules/external/pages/articleEdit/index.vue"),
  meta: {
    title: "文章审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/videoEdit",
  name: "externalvideoEdit",
  component: () => import("@/modules/external/pages/videoEdit/index.vue"),
  meta: {
    title: "视频审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/coursewareEdit",
  name: "externalcoursewareEdit",
  component: () => import("@/modules/external/pages/coursewareEdit/index.vue"),
  meta: {
    title: "课件审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/pptEdit",
  name: "externalPPTEdit",
  component: () => import("@/modules/external/pages/coursewareEdit/index.vue"),
  meta: {
    title: "PPT审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/liveEdit",
  name: "externalliveEdit",
  component: () => import("@/modules/external/pages/liveEdit/index.vue"),
  meta: {
    title: "直播审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/fillInRoomInfo",
  name: "externalFillInRoomInfo",
  component: () => import("@/modules/external/pages/roomInfo/index.vue"),
  meta: {
    title: "直播间数据美化",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/beautifyTargetInfo",
  name: "externalBeautifyTargetInfo",
  component: () => import("@/modules/external/pages/roomInfo/beautifyTargetInfo.vue"),
  meta: {
    title: "直播间数据美化",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/askAndAnswerEdit",
  name: "externalaskAndAnswerEdit",
  component: () => import("@/modules/external/pages/askAndAnswerEdit/index.vue"),
  meta: {
    title: "快问快答审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/healthInterviewEdit",
  name: "externalHealthInterviewEdit",
  component: () => import("@/modules/external/pages/healthInterviewEdit/index.vue"),
  meta: {
    title: "科普专访审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/healthInterpretEdit",
  name: "externalHealthInterpretEdit",
  component: () => import("@/modules/external/pages/healthInterpretEdit/index.vue"),
  meta: {
    title: "健康解读审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/liveActivityEdit",
  name: "externalLiveActivityEdit",
  component: () => import("@/modules/external/pages/liveActivityEdit/index.vue"),
  meta: {
    title: "公益讲堂审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/medicalMeetActivityEdit",
  name: "externalMedicalMeetActivityEdit",
  component: () => import("@/modules/external/pages/medicalMeetActivityEdit/index.vue"),
  meta: {
    title: "医学会议审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}, {
  path: "/external/audioEdit",
  name: "externalAudioEdit",
  component: () => import("@/modules/external/pages/audioEdit/index.vue"),
  meta: {
    title: "音频审订",
    hidden: false,
    icon: "tree",
    isNew: true
  }
}];
export default routes;